/* unplugin-vue-components disabled */import { render } from "./logoffConfirmHK.vue?vue&type=template&id=e9fa0952&scoped=true"
import script from "./logoffConfirmHK.vue?vue&type=script&lang=js"
export * from "./logoffConfirmHK.vue?vue&type=script&lang=js"

import "./logoffConfirmHK.vue?vue&type=style&index=0&id=e9fa0952&scoped=true&lang=css"

import exportComponent from "E:\\IDEAWorkSpace\\parent-net-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9fa0952"]])

export default __exports__